/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      if ( $( '.related' ).length ) {
        $( '.related-slider__slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.related-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '1rem',
            perPage: 4,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );
          splide.on( 'overflow', function( isOverflow ) {
            splide.go( 0 );
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
            };
          } );
          splide.mount( {} );
        } );
      }
      if ( $( '.up-sells' ).length ) {
        $( '.upsell-slider' ).find( '.product' ).each( function( index, element ) {
          $( element ).addClass( 'splide__slide' );
        } );
        $( '.upsell-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '1rem',
            perPage: 4,
            perMove: 1,
            pagination: false,
            speed: 800,
            breakpoints: {
              1024: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } );
          splide.on( 'overflow', function( isOverflow ) {
            splide.go( 0 );
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
            };
          } );
          splide.mount( {} );
        } );
      }
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'woocommerce-related', COMPONENT );
} )( app );
